import {Image, Pressable, StyleSheet} from "react-native"
import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text, useI18n, View} from "shared/base"
import ActionBone from "./action-bone.png"
import ActionBrainBreak from "./action-brain-break.png"
import ActionChallenge from "./action-challenge.png"
import AppHistory from "shared/history"
import {digg} from "diggerize"
import {FlashNotifications as FlashMessage} from "flash-notifications"
import {loading} from "components/layout/loading-blocker"
import React from "react"
import Routes from "shared/routes"
import {SchoolClass} from "models"

const styles = StyleSheet.create({
  button: {
    padding: 24,
    marginTop: 27,
    backgroundColor: "#5253ff",
    borderRadius: 36
  },
  buttonText: {
    color: "#fff",
    fontFamily: "HankenGrotesk",
    fontSize: 24,
    textAlign: "center"
  },
  card: {
    width: 320,
    padding: 40,
    backgroundColor: "#fff",
    border: "2px solid rgb(82, 83, 255)",
    borderRadius: 48,
    boxShadow: "0 10px 15px rgb(0 0 0 / 0.3)"
  },
  iconImage: {
    width: 40,
    height: 40,
    marginLeft: "auto",
    marginRight: "auto"
  },
  iconTitle: {
    color: "#1b1f72",
    fontFamily: "HankenGrotesk",
    fontSize: 24,
    textAlign: "center"
  },
  rootView: {
    flexDirection: "row",
    justifyContent: "center"
  },
  title: {
    color: "#1b1f72",
    fontFamily: "HankenGrotesk",
    fontSize: 48,
    textAlign: "center"
  }
})

export default memo(shapeComponent(class RoutesUserSchoolClassesClassSpaceActions extends ShapeComponent {
  static propTypes = propTypesExact({
    onStartBrainBreak: PropTypes.func.isRequired,
    onStartChallenge: PropTypes.func.isRequired,
    schoolClass: PropTypes.instanceOf(SchoolClass).isRequired
  })

  setup() {
    const {t} = useI18n({namespace: "js.routes.user.school_classes.class_space.actions"})

    this.setInstance({t})
  }

  render() {
    const {t} = this.tt

    return (
      <View dataSet={this.rootViewDataSet ||= {route: "user/school-classes/class-space/actions"}} style={styles.rootView}>
        <View style={styles.card}>
          <Image source={ActionBone} style={styles.iconImage} />
          <Text style={styles.iconTitle}>
            {t(".start_a_new")}
          </Text>
          <Text style={styles.title}>
            {t(".woof")}
          </Text>
          <Pressable
            dataSet={this.startWoofButtonDataSet ||= {class: "start-woof-button"}}
            onPress={this.tt.onStartWoofPress}
            style={styles.button}
          >
            <Text style={styles.buttonText}>
              {t(".start_woof")}
            </Text>
          </Pressable>
        </View>
        <View style={{marginHorizontal: 24}}>
          <View style={styles.card}>
            <Image source={ActionChallenge} style={styles.iconImage} />
            <Text style={styles.iconTitle}>
              {t(".this_weeks")}
            </Text>
            <Text style={styles.title}>
              {t(".challenge")}
            </Text>
            <Pressable
              dataSet={this.startChallengeButtonDataSet ||= {class: "start-challenge-button"}}
              onPress={this.tt.onStartChallengePress}
              style={styles.button}
            >
              <Text style={styles.buttonText}>
                {t(".start_challenge")}
              </Text>
            </Pressable>
          </View>
        </View>
        <View style={styles.card}>
          <Image source={ActionBrainBreak} style={styles.iconImage} />
          <Text style={styles.iconTitle}>
            {t(".instant")}
          </Text>
          <Text style={styles.title}>
            {t(".brain_break")}
          </Text>
          <Pressable
            dataSet={this.startBrainBreakButtonDataSet ||= {class: "start-brain-break-button"}}
            onPress={this.tt.onStartBrainBreakPress}
            style={styles.button}
          >
            <Text style={styles.buttonText}>
              {t(".start_brain_break")}
            </Text>
          </Pressable>
        </View>
      </View>
    )
  }

  onStartChallengePress = () => this.p.onStartChallenge()

  onStartWoofPress = async () => {
    try {
      await loading(null, async () => {
        const result = await this.p.schoolClass.randomCheckIn()
        const schoolClassCheckIn = digg(result, "school_class_check_in")

        AppHistory.push(Routes.userSchoolClassCheckInLobbyPath(schoolClassCheckIn.id()))
      })
    } catch (error) {
      FlashMessage.errorResponse(error)
    }
  }

  onStartBrainBreakPress = () => this.p.onStartBrainBreak()
}))
